import { string, object } from 'yup';

const schema = object({
  bio: string().max(1000, 'Must be maximum 1000 symbols'),
});

export default schema;
